import { useFormContext } from "react-hook-form";
import { IParcelasCustasRequest } from "../../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";

export function RegistrarCustas() {
    const formLancamentoCusta = useFormContext<IParcelasCustasRequest>();
    const { register, formState } = formLancamentoCusta;

    return (
        <>
            <div className="d-flex flex-wrap justify-content-between col-12 mt-6">
                <textarea
                    rows={7}
                    name="Observacao"
                    className={`form-control placeholder-dark-45 h-200 ${
                        formState.errors.Observacao && "is-invalid"
                    } box-mark`}
                    placeholder="Observação:"
                    ref={register()}
                />
            </div>
        </>
    );
}
